import { writable } from 'svelte/store';
export const speak = writable({
    speaking: false,
    selif: ''
});
